import { render, staticRenderFns } from "./EditCustomerDetails.vue?vue&type=template&id=65f4da61&"
import script from "./EditCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./EditCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditCustomerDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports